import ReactSelect from "react-select";

const Select = ({
  label,
  options = [],
  handleChange = null,
  value,
  defaultValue,
  isDisabled = false,
  isMulti = false,
  isClearable = false,
  meta,
}) => {
  const isError = meta && meta.touched && meta.invalid;
  const customStyles = {
    control: (styles) => ({
      ...styles,
      borderColor: isError ? "#ff0000" : "#E2E5EC",
      minHeight: 30,
    }),
    option: (provided) => ({
      ...provided,
      fontFamily: "Poppins",
      fontSize: "13px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontFamily: "Poppins",
      fontSize: "13px",
      padding: 0,
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      display: "none",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontFamily: "Poppins",
      fontSize: "13px",
    }),
  };

  return (
    <div className={`form-group ${isError ? "error" : ""}`}>
      {Boolean(label) && <label className="label-form">{label}</label>}
      <ReactSelect
        placeholder="Wybierz..."
        isMulti={isMulti}
        styles={customStyles}
        defaultValue={defaultValue || null}
        isSearchable={true}
        menuShouldScrollIntoView={true}
        options={options}
        isDisabled={isDisabled}
        isClearable={isClearable}
        value={value}
        onChange={(val) => {
          if (typeof handleChange !== "function") return;
          if (val == null) {
            handleChange(null);
            return;
          }
          handleChange(isMulti ? val.map(({ value }) => value) : val.value);
        }}
        theme={(theme) => ({
          ...theme,
          fontFamily: "Poppins",
          borderRadius: 4,
          colors: {
            ...theme.colors,
            neutral20: "#E2E5EC",
          },
          error: meta && meta.touched && meta.invalid,
        })}
      />
      {isError && meta.error && <p className="inp-error">{meta.error}</p>}
    </div>
  );
};

export default Select;
